<template>
  <div id="myLogin"></div>
</template>
<script>
export default {
  data() {
    return {
      //
      token : this.$route.query.token,
      user : this.$route.query.mobile
    };
  },
  watch: {},
  created() {
    this.$store.state.isLogin = true;
    this.$cookies.set("token", this.$route.query.token);
    this.$cookies.set("user", this.$route.query.mobile);
    if (
      this.$cookies.get("returnPath") == "/login" ||
      this.$cookies.get("returnPath") == "/register"
    ) {
      this.$router.push("/");
    } else {
      this.$router.push(this.$cookies.get("returnPath"));
    }
  },
 
};
</script>